__turbopack_context__.v({
  "chevronExpanded": "Section-module-scss-module__FZ_eDa__chevronExpanded",
  "chevronIcon": "Section-module-scss-module__FZ_eDa__chevronIcon",
  "content": "Section-module-scss-module__FZ_eDa__content",
  "delimiter": "Section-module-scss-module__FZ_eDa__delimiter",
  "headerButton": "Section-module-scss-module__FZ_eDa__headerButton",
  "headerContent": "Section-module-scss-module__FZ_eDa__headerContent",
  "headerText": "Section-module-scss-module__FZ_eDa__headerText",
  "plusIcon": "Section-module-scss-module__FZ_eDa__plusIcon",
  "root": "Section-module-scss-module__FZ_eDa__root",
});
